import { render } from "./AudienceSegments.vue?vue&type=template&id=6bfdd26b&scoped=true"
import script from "./AudienceSegments.vue?vue&type=script&lang=js"
export * from "./AudienceSegments.vue?vue&type=script&lang=js"

import "./AudienceSegments.vue?vue&type=style&index=0&id=6bfdd26b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfdd26b"]])

export default __exports__